import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import Root from './Root';
// require('dotenv').config();

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);


root.render(
    <Root />
);
